// extracted by mini-css-extract-plugin
export var button = "_1a-0";
export var buttonContent = "_1a-e";
export var buttonGroup = "_1a-c";
export var dontRestrainIconWidth = "_1a-a";
export var dropdownButton = "_1a-b";
export var iconContainer = "_1a-9";
export var lg = "_1a-4";
export var md = "_1a-3";
export var pending = "_1a-f";
export var sm = "_1a-2";
export var spinner = "_1a-d";
export var squared = "_1a-8";
export var wrapText = "_1a-g";
export var xl = "_1a-5";
export var xs = "_1a-1";
export var xxl = "_1a-6";
export var xxxl = "_1a-7";